
import React from "react";

type Callback = (() => void) | undefined;

interface CallbackProps {
    callback?: Callback;
    children: React.ReactNode;
}

interface CallbackComponentProps {
    callback?: Callback;
}

const CallbackComponent: React.FC<CallbackComponentProps> = ({ callback }) => {
    React.useEffect(() => {
        callback && callback();
    }, []);

    return null;
};

const RenderCallback: React.FC<CallbackProps> = ({ callback, children }) => {
    return (
        <>
            {children}
            <CallbackComponent callback={callback} />
        </>
    );
};

export default RenderCallback;
